module.exports = __webpack_public_path__ + "img/reviews-slider-bg.bcb7f163.jpg";